"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.default = theme => ({
    root: {
        minHeight: constants_1.MIN_TARGET_SIZE + 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        boxSizing: 'border-box',
        appearance: 'none',
        flexShrink: 0,
        flexGrow: 1,
        cursor: 'default',
        outline: 'none',
        paddingLeft: 7,
        paddingRight: 14,
        fontSize: 14,
        fontWeight: 400,
        color: theme.grey1,
        position: 'relative',
        marginLeft: 0,
        marginRight: 0,
        backgroundColor: theme.white1,
        '&:hover': {
            backgroundColor: theme.grey8
        },
        '&[data-is-selected="true"]': {
            backgroundColor: theme.grey8
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }
    },
    prefix: {
        marginRight: 7,
        width: 14,
        flexShrink: 0
    }
});
//# sourceMappingURL=option.style.js.map